import type {ProfileModelType} from "#shared-package/profile-model.ts";

export type EmailToVerify = {
    email: string;
};

const getEmailsToVerify = (
    profile?: ProfileModelType | null,
): Array<Readonly<EmailToVerify>> => {
    if (!profile) {
        return [];
    }

    const result: Array<Readonly<EmailToVerify>> = [];

    const signupDataIfUnverified = profile.get("signupDataIfUnverified");
    if (signupDataIfUnverified) {
        result.push({
            email: signupDataIfUnverified.email,
        });
    }

    if (profile.get("isPhantom") || profile.get("isChildAccount")) {
        return result;
    }

    if (profile.get("authEmails").length > 0) {
        return result;
    }

    const pendingEmailVerifications = profile.get("pendingEmailVerifications");
    if (pendingEmailVerifications?.length > 0) {
        result.push(...pendingEmailVerifications);
    }

    return result;
};

// Returns the first EmailToVerify that for the profile if there is one.
export const getPendingEmailToVerify = (
    profile?: ProfileModelType | null,
): Readonly<EmailToVerify> | null | undefined => {
    return getEmailsToVerify(profile)[0] ?? null;
};
